import axios from 'axios';
import { POST } from '../../../utils/axios-interceptor';

export function fetchSearchResults(payload: any, cancelToken?: any) {
    return axios({
        method: POST,
        url: API_ENDPOINTS.GLOBAL_SEARCH,
        data: payload,
        cancelToken, // Attach the token if present
    });
}

export function fetchCompanyInfoSearch(payload: any, cancelToken?: any) {
    return axios({
        method: POST,
        url: API_ENDPOINTS.COMPANY_INFO_SEARCH,
        data: payload,
        cancelToken,
    });
}

const API_ENDPOINTS = {
    GLOBAL_SEARCH: '/portfolio/v2/global/search',
    COMPANY_INFO_SEARCH: '/portfolio/company/info',
};
